import { render } from "./stock_locaction.vue?vue&type=template&id=4da037cc&scoped=true"
import script from "./stock_locaction.vue?vue&type=script&lang=js"
export * from "./stock_locaction.vue?vue&type=script&lang=js"

import "./stock_locaction.vue?vue&type=style&index=0&id=4da037cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4da037cc"]])

export default __exports__